import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlGridTagNames, AtlGridTwoColsProps } from './grid.props';
import classNames from 'classnames';
import { getGlobalStyleSheets } from '../../global-styles';

@customElement(AtlGridTagNames.GridTwoCols)
export class AtlGridTwoCols extends LitElement implements AtlGridTwoColsProps {
   declare internalId: string;
   declare internalClassName?: string;
   declare internalColClassName?: string;
   declare internalCol2ClassName?: string;

   static properties = {
      internalId: { type: String },
      internalClassName: { type: String },
      internalColClassName: { type: String },
      internalCol2ClassName: { type: String },
   };

   constructor() {
      super();
      this.internalId = '';
      this.internalClassName = '';
      this.internalColClassName = '';
      this.internalCol2ClassName = '';
   }

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   render() {
      return html`
         <div
            id=${this.internalId}
            class=${`row grid-nested-two-col ${this.internalClassName || ''}`}
         >
            <div class=${classNames('col-md-6', this.internalColClassName)}>
               <slot name="slotCol1"></slot>
            </div>
            <div class=${classNames('col-md-6', this.internalCol2ClassName)}>
               <slot name="slotCol2"></slot>
            </div>
         </div>
      `;
   }
}
